// Any config specific to EGYPT?

export default {
  code: 'EG',
  countryName: 'Egypt',
  // googleSiteVerificationCode: 'Rl8IaimqYqudsttW90pG6FLAfbG99rC4t78gaiSRekU',
  googleSiteVerificationCode: [
    '4eJP6ixvynxQsRovIAGLM3s54WYvZ3KUnjpvYsC0Dl0',
    'oPuMgoH-RycGPuSWkDvTPGVkjcX6mmK0FqKv-I5hH-w',
    'z5oGHqYAkAhSudPCFFhXvyYJKBmxOszKaV7HWEE8ZPA'
  ],
  countryDomain: 'https://www.carrefouregypt.com',
  helplineNumber: '16061',
  latitude: 30.1279,
  longitude: 31.33,
  countryFlagIcon: 'EG_bceab67933.png',
  defaultAreaCode: 'Maadi - Cairo',
  features: {
    languageChange: true,
    now: true,
    share: false,
    isLocationCXEnable: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: '1f04b37a-fa6e-4a80-b7cd-3325c85f8a38'
  },
  metaVerificationTag: '413e82054a'
}
